import { Calendar, Phone, Plus } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function StartYourProject() {
  return <section data-section-id="265044" id="start-your-project" className="relative py-24 lg:py-32 overflow-hidden bg-obsidian text-pure-white">
      {}
      <div className="absolute inset-0 opacity-20 pointer-events-none">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1689812/img/architectural_blueprint_bg.webp" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1689812/img/architectural_blueprint_bg.webp-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1689812/img/architectural_blueprint_bg.webp-wvc-sizes" alt="Architectural background" className="w-full h-full object-cover grayscale" loading="lazy" />
      </div>

      {}
      <div className="absolute top-0 left-0 w-full h-px bg-gold-ochre/30" />
      <div className="absolute bottom-0 left-0 w-full h-px bg-gold-ochre/30" />
      
      <div className="container relative z-10 mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-5xl mx-auto">
          <div className="flex flex-col lg:flex-row items-center justify-between gap-12 lg:gap-20">
            
            <div className="flex-1 text-left">
              <div className="inline-flex items-center gap-2 mb-6">
                <span className="font-mono text-[10px] uppercase tracking-widest text-gold-ochre">
                  Phase 01: Initiation
                </span>
                <div className="h-px w-12 bg-gold-ochre" />
              </div>
              
              <h2 className="font-sans text-4xl md:text-6xl font-bold tracking-tight leading-tight mb-8 uppercase">
                Creating Spaces <br />
                <span className="text-gold-ochre">With Purpose.</span>
              </h2>
              
              <p className="font-sans text-lg md:text-xl text-concrete max-w-xl leading-relaxed">
                From architectural planning to turnkey construction, ArchiForma delivers modern, functional, and high-quality solutions tailored to your vision.
              </p>
            </div>

            <div className="w-full lg:w-auto flex flex-col sm:flex-row lg:flex-col gap-4">
              <Button asChild size="lg" className="h-16 px-10 text-lg font-semibold bg-gold-ochre text-obsidian hover:bg-gold-ochre/90 rounded-md shadow-depth transition-all group">
                <Link to="/HomePage">
                  <Plus className="mr-2 size-5 transition-transform group-hover:rotate-90" />
                  Start Your Project
                </Link>
              </Button>
              
              <Button asChild variant="outline" size="lg" className="h-16 px-10 text-lg font-semibold border-concrete text-pure-white hover:bg-pure-white/10 rounded-md transition-all">
                <Link to="/HomePage">
                  <Phone className="mr-2 size-5" />
                  Contact Studio
                </Link>
              </Button>

              <div className="mt-4 flex items-center justify-center lg:justify-start gap-4 opacity-50">
                <span className="font-mono text-[10px] uppercase tracking-tighter">EST 2007</span>
                <div className="size-1 rounded-lg bg-concrete" />
                <span className="font-mono text-[10px] uppercase tracking-tighter">Full-Turnkey</span>
              </div>
            </div>

          </div>
        </div>
      </div>

      {}
      <div className="absolute top-8 left-8 opacity-20">
        <Plus className="size-6 text-gold-ochre" />
      </div>
      <div className="absolute bottom-8 right-8 opacity-20">
        <Plus className="size-6 text-gold-ochre" />
      </div>
    </section>;
}